module.exports = __webpack_public_path__ + "img/info.05234c7b.svg";